import { render, staticRenderFns } from "./EquityPoolList.vue?vue&type=template&id=4c15b6ba&scoped=true&"
import script from "./EquityPoolList.vue?vue&type=script&lang=js&"
export * from "./EquityPoolList.vue?vue&type=script&lang=js&"
import style0 from "./EquityPoolList.vue?vue&type=style&index=0&id=4c15b6ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c15b6ba",
  null
  
)

export default component.exports